(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabScheduleStatus', TabScheduleStatus);

    TabScheduleStatus.$inject = ['$resource'];

    function TabScheduleStatus ($resource) {
        var resourceUrl =  'api/tab-schedule-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
